import Avatar from '@jimmyboys/liita-ui/dist/components/Avatar'
import Icon from '@jimmyboys/liita-ui/dist/components/Icon'
import Tooltip from '@jimmyboys/liita-ui/dist/components/Tooltip'
import styles from './MedicalOpinionTriageCard.module.sass'
import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import { extendedLateralityOptions } from 'controllers/TaskManager/formOptions'

const { memo } = require('react')

export const RenderBodyParts = (props) => {
	const { bodyParts, isRenderedInWidget } = props
	const { i18n } = useGlobal()

	return (
		<div className={styles['body-parts-grid']}>
			<div className={`${styles['sub-grid-item']}`}>
				<h5>{i18n`Body part`}</h5>
				<h5>{i18n`Injury`}</h5>
				<h5>{i18n`Laterality`}</h5>
			</div>

			{bodyParts?.map((item, index) => (
				<HStack
					className={`${styles['sub-grid-item']} ${
						isRenderedInWidget
							? styles['--body-parts-widget-grid']
							: ''
					}`}
					key={index}
				>
					<HStack gap='xsmall'>
						<small>{item?.trustBodyPart?.name}</small>
						{item?.isMainBodyPart && (
							<Tooltip text={i18n`Primary body part` || ''}>
								<i className={styles['star']}></i>
							</Tooltip>
						)}
					</HStack>
					<div>
						<small>{item?.injuryType?.name}</small>
					</div>
					<div>
						<small>
							{
								extendedLateralityOptions.find(
									(element) =>
										element.value ===
										item?.laterality?.toString()
								)?.text
							}
						</small>
					</div>
				</HStack>
			))}
		</div>
	)
}

const MedicalOpinionTriageCard = memo((props) => {
	const { className, data, ...attributes } = props
	const labels = data.$cardLabels || {}

	return (
		<div
			{...attributes}
			className={`card ${styles['root'] || ''} ${className || ''} ${
				styles[`${data?.$layout}-layout`] || ''
			}`}
		>
			<span className={styles['status-circle']} />
			<div className={styles['header-content']}>
				<span>
					<h5>
						<Icon
							className={styles['text-icon']}
							name='calendar'
							width='14px'
							height='14px'
						/>
						{data?.responseDate?.shortDateFormat ||
							data?.creationDate?.shortDateFormat}
					</h5>
					<small>{labels?.medicalOpinion}</small>
				</span>
				<div className={`${styles['status-container']}`}>
					<div>
						<h5>
							{data?.responseUser?.name ||
								data?.creationUser?.name}
						</h5>
						<small>{data?.medicalObservationType}</small>
					</div>
					<span className={styles['avatar-container']}>
						<Avatar
							rounded
							className={styles['avatar']}
							user={data?.responseUser || data?.creationUser}
						/>
					</span>
				</div>
			</div>

			{data.$detailLevel !== 'summary' && (
				<div className={styles['card-content']}>
					{data.responseUser && (
						<>
							{/*CM 196 hide profession */}
							{/* Não mostrar a lista de dados em falta — aparece vazio */}
							{/* {!data.missingTriageData.isMissing && (
								<div className={styles['missing-data-content']}>
									<h5>{data.missingTriageData.label}</h5>
									<span>
										<small>
											{data.missingTriageData.answer}
										</small>
									</span>
								</div>
							)} */}
							<div>
								<RenderBodyParts bodyParts={data?.bodyParts} />
								<div className={`${styles['answers-grid']}`}>
									<div className={`${styles['grid-item']}`}>
										<Tooltip
											text={
												data.mechanism?.question || ''
											}
										>
											<h5>
												{data.mechanism?.shortLabel}
											</h5>
										</Tooltip>
										<span>
											<small>
												{data.mechanism?.answer}
											</small>
										</span>
									</div>

									<div className={`${styles['grid-item']}`}>
										<Tooltip
											text={
												data.diagnosisTriage
													?.question || ''
											}
										>
											<h5>
												{
													data.diagnosisTriage
														?.shortLabel
												}
											</h5>
										</Tooltip>
										<span>
											<small>
												{data.diagnosisTriage?.answer}
											</small>
										</span>
									</div>
									<div className={`${styles['grid-item']}`}>
										<Tooltip
											text={
												data
													.diagnosesWithCausalLinkMechanism
													.question || ''
											}
										>
											<h5>
												{
													data
														.diagnosesWithCausalLinkMechanism
														.shortLabel
												}
											</h5>
										</Tooltip>
										<span>
											<small>
												{
													data
														.diagnosesWithCausalLinkMechanism
														.answer
												}
											</small>
										</span>
									</div>
									<div className={`${styles['grid-item']}`}>
										<Tooltip
											text={
												data.biologicRiskTriage
													.question || ''
											}
										>
											<h5>
												{
													data.biologicRiskTriage
														.shortLabel
												}
											</h5>
										</Tooltip>
										<span>
											<small>
												{data.biologicRiskTriage.answer}
											</small>
										</span>
									</div>
								</div>
								<div className={`${styles['answers-grid']}`}>
									<div className={`${styles['grid-item']}`}>
										<Tooltip
											text={
												data
													.isPreviouslyPerformedSurgeryTriage
													?.question || ''
											}
										>
											<h5>
												{
													data
														.isPreviouslyPerformedSurgeryTriage
														?.shortLabel
												}
											</h5>
										</Tooltip>
										<span>
											<small>
												{
													data
														.isPreviouslyPerformedSurgeryTriage
														?.answer
												}
											</small>
										</span>
									</div>

									<div className={`${styles['grid-item']}`}>
										<h5>
											{
												data.canTransferProcessTriage
													?.question
											}
										</h5>
										<span>
											<small>
												{
													data
														.canTransferProcessTriage
														?.answer
												}
											</small>
										</span>
									</div>
									<div className={`${styles['grid-item']}`}>
										<h5>
											{
												data.processComplexityTriage
													?.question
											}
										</h5>
										<span>
											<small>
												{
													data.processComplexityTriage
														?.answer
												}
											</small>
										</span>
									</div>
									{/*CM 196 hide profession */}
									{/* <div className={`${styles['grid-item']}`}>
										<h5>
											{
												data?.processDurationTriage
													?.question
											}
										</h5>
										<span>
											<small>
												{
													data?.processDurationTriage
														?.answer
												}
											</small>
										</span>
									</div> */}
									{data?.acutePhase !== null &&
										data?.acutePhase !== undefined && (
											<div
												className={`${styles['grid-item']}`}
												style={{ gridColumn: 'span 2' }}
											>
												<h5>
													{labels?.acutePhase ||
														'Tratamento Fase Aguda'}
												</h5>
												<span>
													<small>
														{data.acutePhase
															? labels?.yes ||
															  'Sim'
															: labels?.no ||
															  'Não'}
														{/* CM - data de notificação da fase aguda comentada */}
														{/* {data.acutePhase &&
															data?.acutePhaseNotificationDate &&
															` - ${new Date(
																data.acutePhaseNotificationDate
															).toLocaleDateString(
																'pt-PT'
															)}`} */}
													</small>
												</span>
											</div>
										)}
								</div>
								<div className={`${styles['observations']}`}>
									<h5>{data?.observationTriage?.question}</h5>
									<p>{data?.observationTriage?.answer}</p>
								</div>
							</div>
						</>
					)}

					<div className={`${styles['request']}`}>
						<h5>{data?.requestedByDate}</h5>
						<p>{data?.submittedMedicalRequest}</p>
					</div>
				</div>
			)}
		</div>
	)
})

MedicalOpinionTriageCard.displayName = 'MedicalOpinionTriageCard'
MedicalOpinionTriageCard.defaultHeight = 300
MedicalOpinionTriageCard.missingDataLabelSize = 17
MedicalOpinionTriageCard.UnanswerdDefaultHeight = 50
MedicalOpinionTriageCard.UnanswerdMobileDefaultHeight = 65
MedicalOpinionTriageCard.mobileDefaultHeight = 360
MedicalOpinionTriageCard.groupMargin = 20
MedicalOpinionTriageCard.summaryDefaultHeight = 50

export default MedicalOpinionTriageCard
